import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'clsx';
import PrerollSlider from './PrerollSlider';
import PrerollVolumeController from './PrerollVolumeController';
import PrerollMediaButtons from './PrerollMediaButtons';
import css from './preroll-controls.module.scss';

export class PrerollControls extends Component {
  static propTypes = {
    isMinimized: PropTypes.bool.isRequired,
    learnMoreUrl: PropTypes.string,
  };

  render() {
    const { isMinimized, learnMoreUrl } = this.props;
    const minimizedOrExpandedClassName = isMinimized
      ? css.minimized
      : css.expanded;

    return (
      <div
        className={classNames(
          css.prerollControlContainer,
          minimizedOrExpandedClassName,
        )}
      >
        <div
          className={classNames(
            css.prerollMediaButtonsContainer,
            minimizedOrExpandedClassName,
          )}
        >
          <PrerollMediaButtons isMinimized={isMinimized} />
        </div>
        <div
          className={classNames(
            css.prerollSliderContainer,
            minimizedOrExpandedClassName,
          )}
        >
          <PrerollSlider isMinimized={isMinimized} />
        </div>
        <div
          className={classNames(
            css.prerollRightSideControls,
            minimizedOrExpandedClassName,
          )}
        >
          {learnMoreUrl && (
            <a
              data-testid="learnMoreUrl"
              className={classNames(
                css.learnMore,
                minimizedOrExpandedClassName,
              )}
              href={learnMoreUrl}
              target="_blank"
            >
              <div
                className={classNames(
                  css.learnMoreText,
                  minimizedOrExpandedClassName,
                )}
              >
                Learn More
              </div>
            </a>
          )}
          <div
            className={classNames(
              css.prerollVolumeContainer,
              minimizedOrExpandedClassName,
            )}
          >
            <PrerollVolumeController isMinimized={isMinimized} />
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  const { learnMoreUrl } = state.preroll;
  return {
    learnMoreUrl,
  };
}

export default connect(mapStateToProps)(PrerollControls);
